import React from 'react';
import { X } from 'lucide-react';

const RESET_KEYS = {
  year: ['yearFrom', 'yearTo'],
  country: ['country'],
  tradingCountry: ['tradingCountry'],
  value: ['valueMin', 'valueMax'],
  weight: ['weightMin', 'weightMax'],
  trademark: ['trademark'],
  importer: ['importer'],
  exporter: ['exporter'],
  productCodePrefix: ['productCodePrefix'],
};

export default function AppliedFilterChips({
  chips = [],
  onRemove,
  onApply,
  hasPendingFilterChanges = false,
}) {
  if (chips.length === 0 && !hasPendingFilterChanges) return null;

  const handleRemove = (chip) => {
    const keys = RESET_KEYS[chip.key] || [chip.key];
    keys.forEach(k => onRemove(k, ''));
  };

  return (
    <div className="flex-shrink-0 flex flex-wrap items-center gap-1.5 border-b border-border-default bg-surface px-4 py-1.5 text-xs">
      {chips.length > 0 && (
        <>
          <span className="text-text-muted">Применено:</span>
          {chips.map(chip => (
            <span
              key={chip.key}
              className="inline-flex h-6 items-center gap-1 rounded-md border border-border-default bg-elevated pl-2 pr-1 text-text-secondary"
              title={chip.label}
            >
              <span className="truncate max-w-[180px]">{chip.label}</span>
              <button
                type="button"
                onClick={() => handleRemove(chip)}
                className="grid h-4 w-4 place-items-center rounded text-text-disabled hover:bg-hover hover:text-text-secondary transition-colors"
                aria-label={`Снять фильтр: ${chip.label}`}
              >
                <X className="w-3 h-3" />
              </button>
            </span>
          ))}
        </>
      )}

      {hasPendingFilterChanges && (
        <button
          type="button"
          onClick={onApply}
          className="ml-auto inline-flex h-6 items-center gap-1 rounded-md bg-amber-50 border border-amber-200 px-2 text-[11px] font-medium text-amber-800 hover:bg-amber-100 dark:bg-amber-950/30 dark:border-amber-900/50 dark:text-amber-300 dark:hover:bg-amber-950/50 transition-colors"
          title="Применить изменения фильтров"
        >
          Применить изменения
        </button>
      )}
    </div>
  );
}
